/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlogCreateDto } from '../../models/blog-create-dto';
import { BlogDto } from '../../models/blog-dto';

export interface BlogAdminControllerCreateV1$Params {
      body: BlogCreateDto
}

export function blogAdminControllerCreateV1(http: HttpClient, rootUrl: string, params: BlogAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BlogDto>> {
  const rb = new RequestBuilder(rootUrl, blogAdminControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlogDto>;
    })
  );
}

blogAdminControllerCreateV1.PATH = '/api/v1/blogs/admin';
